import { AutogenModelCopyControlLookup, AutogenRowCopyControlLookup } from "./autogen/AutogenModelCopyControlLookup";

export class ModelCopyControlLookup extends AutogenModelCopyControlLookup<RowCopyControlLookup> {
	constructor() {
		super(RowCopyControlLookup);
	}
}

export class RowCopyControlLookup extends AutogenRowCopyControlLookup {
}